import { TableCell } from "@mui/material";
import { IFreezeReleaseCalculationsTableReport } from "../../../Interfaces/freeze";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import Button from "../../../Components/Button";
import { SendOutlined } from "@ant-design/icons";
import { useState } from "react";
import {
  addBulkReleaseRequest,
  addReleaseRequest,
  editReleaseCalc,
} from "../../../Requests/freeze";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import SimpleTextInput from "../../../Components/SimpleTextInput";
import EditIcon from "@mui/icons-material/Edit";

const AdditionalHeader = ({
  onAction,
  selectedRowsIds,
  setSelectedRowsIds,
}: IAdditionalHeaderProps) => {
  const [bulkReleaseLoading, setBulkReleaseLoading] = useState(false);

  const bulkAddReleaseHandler = () => {
    if (!selectedRowsIds.length) return;
    setBulkReleaseLoading(true);
    addBulkReleaseRequest(selectedRowsIds)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          setSelectedRowsIds([]);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setBulkReleaseLoading(false));
  };

  return (
    <>
      <TableCell>
        <Button
          text={<SendOutlined className="!text-sm" />}
          variant="outlined"
          className="table-btn"
          onClick={bulkAddReleaseHandler}
          loading={bulkReleaseLoading}
          disabled={bulkReleaseLoading || !selectedRowsIds.length}
        />
      </TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IFreezeReleaseCalculationsTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [addReleaseLoading, setAddReleaseLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [amount, setAmount] = useState(row.amount);

  const addReleaseHandler = () => {
    setAddReleaseLoading(true);
    addReleaseRequest(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setAddReleaseLoading(false));
  };

  const editHandler = () => {
    setEditLoading(true);
    editReleaseCalc({ amount, requestId: row.id })
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setEditLoading(false));
  };

  return (
    <>
      <TableCell>
        <Button
          text={<SendOutlined className="!text-sm" />}
          variant="contained"
          className="table-btn"
          onClick={addReleaseHandler}
          loading={addReleaseLoading}
        />
      </TableCell>
      <TableCell>
        <div className="flex flex-row justify-start items-center gap-3">
          <div className="w-32">
            <SimpleTextInput
              name=""
              onChange={(_, value) => setAmount(value)}
              placeholder="مقدار"
              kind="number"
              value={amount?.toString()}
            />
          </div>
          <div className="w-32">
            <Button
              text={<EditIcon className="!text-sm" />}
              variant="contained"
              className="table-btn"
              onClick={editHandler}
              loading={editLoading}
            />
          </div>
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IFreezeReleaseCalculationsTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
